import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { ClassBookFolder } from './class-book-folder.model';
import { ClassBookFolderInterface } from './class-book-folder.interface';
import { ClassBookFolderFactory } from './class-book-folder.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class ClassBookFolderService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<ClassBookFolder>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<ClassBookFolderInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/class-book-folders`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => ClassBookFolderFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<ClassBookFolder> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<ClassBookFolderInterface>(`${environment.apiUrl}/v${environment.apiVersion}/class-book-folders/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => ClassBookFolderFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(classBookFolder: ClassBookFolder): Observable<any> {
        if (classBookFolder.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/class-book-folders/${classBookFolder.id}`, classBookFolder, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/class-book-folders`, classBookFolder, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/class-book-folders/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    /*remove(isbn: string): Observable<any> {
        return this.http
            .delete(`${this.api}/class-book-folder/${isbn}`, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }
 */

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<ClassBookFolder>> {
        return this.http
            .get<ClassBookFolderInterface[]>(`${this.api}/class-book-folders/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawClassBookFolder => ClassBookFolderFactory.fromObject(rawClassBookFolder)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/class-book-folders/shared/class-book-folder.service.ts